<template>
  <div class="exercise-choice-root">
    <!-- 题干 -->
    <section class="question-con">
      <!-- 拼音类型无需组件 -->
      <div v-if="questionKey == 'Pinyin'" class="practice-pinyin">{{ currentItem?.pinyin }}</div>
      <component
        v-else
        :is="questionKey"
        :currentItem="currentItem"
        :soundUrl="currentItem?.tts_url"
      >
      </component>
    </section>
    <!-- 选项 -->
    <section class="answer-con">
      <div
        v-for="item in answerOption"
        :key="item.id"
        class="check-con"
        :class="{
          'success-check-con': checkAnswer && item.correct,
          'error-check-con': checkAnswer && wrongIndex == item.index,
        }"
      >
        <template>
          <img
            v-if="checkAnswer && item.correct"
            src="@/assets/images/free-practice/check_right_sml.png"
            class="right-icon"
          />
          <img
            v-else-if="checkAnswer && wrongIndex == item.index"
            src="@/assets/images/free-practice/check_wrong_sml.png"
            class="wrong-icon"
          />
          <div v-else class="check-circle" @click="clickCheckCon(item)"></div>
        </template>
        <!-- 只有sound类型需要组件 -->
        <div v-if="answerKey == 'Sound'" @click="clickSound(item)">
          <MultiSound
            :soundUrl="item?.tts_url"
            :playing="item.fatherPlayStatus"
            :unload.sync="item.unload"
            :id="item.id + ''"
            :loading="item.loading"
            :percent="item.percent"
          ></MultiSound>
        </div>

        <div v-else class="check-text">{{ item[answerContentKey] }}</div>
      </div>
    </section>
  </div>
</template>
<script>
import Meaning from './meaning'
import MultiSound from './player'
import Sound from './singlePlayer'
import Characters from './characters.vue'
export default {
  props: {
    questionKey: {
      type: String,
      default: 'Meaning',
    },
    answerKey: {
      type: String,
      default: 'Sound',
    },
    currentItem: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    currentItem: {
      handler() {
        console.log(this.currentItem)
        this.checkAnswer = false
        this.wrongIndex = null
        if (this.answerKey == 'Sound') {
          this.answerOption = this.currentItem?.option.map((item) => {
            return {
              ...item,
              fatherPlayStatus: false,
              unload: false,
              percent: '0',
              loading: false,
            }
          })
        } else {
          this.answerOption = this.currentItem?.option
        }
      },
      immediate: true,
    },
  },
  computed: {
    answerContentKey() {
      switch (this.answerKey) {
        case 'Meaning':
          return 'translation'
        case 'Sound':
          return 'tts_url'
        case 'Characters':
          return 'characters'
        case 'Pinyin':
          return 'pinyin'
        default:
          return ''
      }
    },
  },
  data() {
    return {
      answerOption: [],
      checkAnswer: false,
      wrongIndex: null,
      currentPlayList: [],
      animationId: '',
    }
  },
  methods: {
    onStep(clickItem) {
      console.log('onStep', clickItem.fatherPlayStatus)
      let seek = 0
      try {
        seek = this.$player.sound.seek()
      } catch (e) {
        console.log(e)
      }
      clickItem.percent = ((seek / this.$player.sound.duration()) * 100).toFixed(1)

      if (clickItem.fatherPlayStatus) {
        this.animationId = requestAnimationFrame(() => {
          this.onStep(clickItem)
        })
      }
    },
    clickSound(clickItem) {
      if (clickItem.loading) {
        return
      }
      if (!clickItem.fatherPlayStatus) {
        this.answerOption.forEach((item) => {
          if (item.tts_url != clickItem.tts_url) {
            item.fatherPlayStatus = false
            item.unload = true
            item.loading = false
            item.percent = '0'
          }
        })
      }

      // 1. 同一文件-
      if (clickItem.tts_url == this.$player.file) {
        if (clickItem.fatherPlayStatus) {
          // 播放中-暂停
          this.$player.sound.pause()
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        } else {
          // 未播放-播放
          clickItem.fatherPlayStatus = true
          this.$player.sound.play()
          this.onStep(clickItem)
        }
      } else {
        clickItem.loading = true
        this.$player.play(clickItem.tts_url, '', {}, false, false, false)

        this.$player.onloaded = (e) => {
          clickItem.loading = false
          clickItem.fatherPlayStatus = true
          this.onStep(clickItem)
        }
        this.$player.onended = () => {
          console.log('onended change')
          clickItem.fatherPlayStatus = false
        }
        this.$player.onpaused = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
        this.$player.onUnload = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
        this.$player.onloaderrored = () => {
          clickItem.fatherPlayStatus = false
          clickItem.loading = false
        }
      }
    },
    clickCheckCon(item) {
      if (this.checkAnswer) {
        return
      }
      this.$emit('choiceGetAnswer', { id: item.id, correct: item.correct })
      if (!item.correct) {
        this.wrongIndex = item.index
      }
      this.checkAnswer = true
    },
  },
  beforeDestroy() {
    this.$player.pause()
    cancelAnimationFrame(this.animationId)
  },
  components: {
    Meaning,
    Sound,
    MultiSound,
    Characters,
  },
}
</script>
<style lang="scss">
@import '../styles/practiceExercise.scss';
.question-con {
  display: flex;
  align-items: center;
  margin: 44px auto;
  width: 660px;
  height: 180px;
  justify-content: center;
}

.answer-con {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 40px;
  margin-top: 14px;
}
</style>
